import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=6510d09a&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=6510d09a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6510d09a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6510d09a')) {
      api.createRecord('6510d09a', component.options)
    } else {
      api.reload('6510d09a', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=6510d09a&scoped=true&", function () {
      api.rerender('6510d09a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iPCjFaz55Qwg/JS/comp/Paginate.vue"
export default component.exports